export default __webpack_public_path__ + "static/media/lety-wallpaper.fb5e7e9d.jpg";